import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import { OffersService } from '../../../../shared/services/admServices/offers.service';

@Component({
  selector: 'admin-offers-topoffers',
  templateUrl: './top-offers.html',
  styleUrls: ['./top-offers.scss'],
})

export class topoffersComponent implements OnInit {

  offersData: any;
  pageSizeDefinition = 5;
  topoffersData: any;

  ColumnMode = ColumnMode;

  constructor(private offersService: OffersService, private toastrService: ToastrService) {

  }

  ngOnInit() {
    this.setPage(5);
  }

  setPage(pagesize){
    this.offersService.getTopOffers(pagesize)
    .subscribe(
     data => {
      this.topoffersData = data.data;
     },
     error => {
       console.log(error);
     });
  }

  onChange(event){
    // wybór ilości oferty do wyświetlenia w tablicy
    this.pageSizeDefinition = Number(event.target.value);
    this.setPage(this.pageSizeDefinition);
  }

  sort(event){
  }
}
